import { motion, useScroll, useTransform } from "motion/react";

export function Hero() {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 150]);
  const opacity = useTransform(scrollY, [0, 300], [1, 0]);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden w-full">
      {/* Background Image with Parallax */}
      <motion.div 
        style={{ y, opacity }}
        className="absolute inset-0 z-0"
      >
        <div className="absolute inset-0 bg-gradient-to-b from-studio-darker/60 via-studio-darker/80 to-studio-dark z-10" />
        <img
          src="https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=1920&fm=avif&fit=crop"
          srcSet="https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=640&fm=avif&fit=crop 640w, https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=1280&fm=avif&fit=crop 1280w, https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=1920&fm=avif&fit=crop 1920w"
          sizes="100vw"
          alt="Ekskluzywne auto poddawane zabiegom detailingu"
          width="1920"
          height="1080"
          loading="eager"
          fetchPriority="high"
          className="w-full h-full object-cover object-center"
        />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="mb-6 inline-flex items-center px-3 py-1 rounded-full border border-studio-gold/30 bg-studio-gold/10 text-studio-gold text-sm font-medium tracking-wide uppercase"
        >
          <span className="w-2 h-2 rounded-full bg-studio-gold mr-2" />
          Bielsko-Biała
        </motion.div>
        
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="text-5xl md:text-7xl lg:text-8xl font-display font-bold text-white tracking-tight mb-6 max-w-4xl"
        >
          Perfekcja w każdym <span className="text-transparent bg-clip-text bg-gradient-to-r from-studio-gold to-yellow-200">detalu</span>
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          className="mt-4 text-lg md:text-xl text-zinc-300 max-w-2xl mx-auto mb-10 font-light"
        >
          Prestige Detailing to najwyższej klasy studio pielęgnacji pojazdów w sercu Podbeskidzia. Przywracamy salonowy blask i bezkompromisowo zabezpieczamy Twoje auto.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
          className="flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#kontakt"
            className="inline-flex justify-center items-center px-8 py-4 text-base font-medium text-black bg-studio-gold hover:bg-studio-gold-hover transition-colors duration-300 rounded-lg shadow-[0_0_20px_rgba(205,164,52,0.3)] hover:shadow-[0_0_30px_rgba(205,164,52,0.5)] focus:outline-none focus:ring-4 focus:ring-white"
          >
            Zarezerwuj termin
          </a>
          <a
            href="#uslugi"
            className="inline-flex justify-center items-center px-8 py-4 text-base font-medium text-white border border-zinc-700 bg-zinc-900/50 hover:bg-zinc-800 hover:border-zinc-600 transition-colors duration-300 rounded-lg backdrop-blur-sm focus:outline-none focus:ring-4 focus:ring-studio-gold"
          >
            Poznaj usługi
          </a>
        </motion.div>
      </div>
      
      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2"
      >
        <span className="text-zinc-400 text-xs uppercase tracking-widest">Przewiń</span>
        <motion.div 
          animate={{ y: [0, 8, 0] }} 
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          className="w-[1px] h-12 bg-gradient-to-b from-studio-gold/80 to-transparent"
        />
      </motion.div>
    </section>
  );
}
